import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', loadChildren: './home/home.module#HomeModule' },
  { path: 'home/:allTeams', loadChildren: './home/home.module#HomeModule' },
  // { path: 'hub', loadChildren: './hub/hub.module#HubModule' },
  { path: 'marketplace', loadChildren: './marketplace/marketplace.module#MarketplaceModule' },
  { path: 'faqs', loadChildren: './faqs/faqs.module#FaqsModule' },
  { path: 'terms-of-service', loadChildren: './terms-of-service/terms-of-service.module#TermsOfServiceModule' },
  { path: 'privacy-policy', loadChildren: './privacy-policy/privacy-policy.module#PrivacyPolicyModule' },
  { path: 'california-privacy-rights', loadChildren: './california-privacy-rights/california-privacy-rights.module#CaliforniaPrivacyRightsModule' },
  { path: 'refund-policy', loadChildren: './refund-policy/refund-policy.module#RefundPolicyModule' },
  { path: 'team', loadChildren: './team/team.module#TeamModule' },
  { path: 'event', loadChildren: './event/event.module#EventModule' },
  { path: 'cart', loadChildren: './cart/cart.module#CartModule' },
  { path: 'checkout', loadChildren: './checkout/checkout.module#CheckoutModule' },
  { path: 'congratulations', loadChildren: './congratulations/congratulations.module#CongratulationsModule' },
  { path: 'account', loadChildren: './account/account.module#AccountModule' },
  { path: 'maintenance-mode', loadChildren: './maintenance-mode/maintenance-mode.module#MaintenanceModeModule' },
  { path: 'error', loadChildren: './error/error.module#ErrorModule' },
  { path: 'cotton-bowl', loadChildren: './event/event.module#EventModule', data: { game: 'cotton-bowl' } },
  { path: 'orange-bowl', loadChildren: './event/event.module#EventModule', data: { game: 'orange-bowl' } },
  { path: 'fiesta-bowl', loadChildren: './event/event.module#EventModule', data: { game: 'fiesta-bowl' } },
  { path: 'peach-bowl', loadChildren: './event/event.module#EventModule', data: { game: 'peach-bowl' } },
  { path: 'sugar-bowl', loadChildren: './event/event.module#EventModule', data: { game: 'sugar-bowl' } },
  { path: 'rose-bowl', loadChildren: './event/event.module#EventModule', data: { game: 'rose-bowl' } },
  { path: 'playoff-semifinal', loadChildren: './event/event.module#EventModule', data: { game: 'playoff-semifinal' } },
  { path: '**', redirectTo: 'home' }
];

@NgModule({
  exports: [
    RouterModule
  ],
  imports: [
    RouterModule.forRoot(routes)
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts